module.exports = __webpack_public_path__ + "img/fast@2x.5332dd57.png";